import { render, staticRenderFns } from "./AvisoArmazenamento.vue?vue&type=template&id=a94a17b8&scoped=true"
import script from "./AvisoArmazenamento.vue?vue&type=script&lang=js"
export * from "./AvisoArmazenamento.vue?vue&type=script&lang=js"
import style0 from "./AvisoArmazenamento.vue?vue&type=style&index=0&id=a94a17b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94a17b8",
  null
  
)

export default component.exports